var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMembersArea = function SvgMembersArea(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.286 1.832c-.758 0-1.485.265-2.02.738-.536.473-.837 1.114-.837 1.783v13.865c0 .669.3 1.31.836 1.783.536.473 1.263.738 2.02.738h21.43c.757 0 1.484-.265 2.02-.738.535-.473.836-1.114.836-1.783V4.353c0-.669-.3-1.31-.836-1.783-.536-.473-1.263-.738-2.02-.738H4.284Zm0-1.26h21.428c1.137 0 2.227.398 3.03 1.107C29.55 2.388 30 3.349 30 4.353v13.865c0 1.003-.451 1.965-1.255 2.674-.804.71-1.894 1.108-3.03 1.108H4.284c-1.136 0-2.226-.398-3.03-1.108C.452 20.183 0 19.222 0 18.218V4.353C0 3.35.452 2.388 1.255 1.679 2.06.969 3.15.57 4.285.57Z",
    fill: "#5981E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.443c-3.593 0-6.624 2.675-6.624 5.845s2.919 5.844 6.623 5.844c3.705 0 6.624-2.675 6.624-5.845s-2.919-5.844-6.624-5.844Zm0 10.896c-3.144 0-5.726-2.278-5.726-5.051 0-2.774 2.582-5.052 5.725-5.052 3.144 0 5.726 2.278 5.726 5.051 0 2.774-2.582 5.052-5.726 5.052Z",
    fill: "#5981E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13.763 8.016 4.715 2.873c.45.198.45.792 0 1.09l-4.715 2.872c-.561.297-1.235-.1-1.235-.595V8.61c0-.594.674-.891 1.235-.594Z",
    fill: "#5981E3"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMembersArea);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bae0d5b8d7f9afc6a43c7d7874b1e9e6.svg";